import { List, Create, Edit, View, PurchaseReturn, BulkSale, OtherCreate } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/sales",
        component: List,
        name: "voucher.fd.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/sales/other",
        component: OtherCreate,
        name: "voucher.fd.other.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/bulk-sales",
        component: BulkSale,
        name: "voucher.fd.bulk.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/sales/create",
        component: Create,
        name: "voucher.fd.sales.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/purchase-return/create",
        component: PurchaseReturn,
        name: "voucher.fd.purchase.return.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/sales/:id/edit",
        component: Edit,
        name: "voucher.fd.sales.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/sales/:id/view",
        component: View,
        name: "voucher.fd.sales.view",
        meta: {
            requiresAuth: true,
        },
    },
];
